<template>
  <div class="pwd-box-wrap" @click="focusInput">
    <ul class="pwd-box-list">
      <li
        v-for="index in 6"
        :key="index"
        class="pwd-box-item"
        :class="{
          active: isFocused && value.length === index - 1,
          filled: value.length >= index,
        }"
      >
        <i v-if="value.length >= index" class="pwd-dot" />
      </li>
    </ul>
    <input
      ref="input"
      :value="value"
      type="tel"
      inputmode="numeric"
      pattern="[0-9]*"
      maxlength="6"
      class="pwd-hidden-input"
      autocomplete="one-time-code"
      @input="onInput"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />
  </div>
</template>

<script>
export default {
  name: 'PwdBoxInput',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
  methods: {
    focusInput() {
      this.$refs.input && this.$refs.input.focus();
    },
    onInput(event) {
      const v = String(event.target.value || '')
        .replace(/\D/g, '')
        .slice(0, 6);
      event.target.value = v;
      this.$emit('input', v);
      if (v.length >= 6) {
        this.$emit('complete');
      }
    },
  },
};
</script>

<style scoped>
.pwd-box-wrap {
  position: relative;
  width: 80%;
  max-width: 340px;
  margin: 0 auto;
  cursor: text;
}

.pwd-box-list {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.pwd-box-item {
  flex: 1;
  height: 52px;
  min-width: 0;
  background-color: #ebedf0;
  border-radius: 12px;
  border: 2px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.pwd-box-item.active {
  border-color: #e8afbd;
}

.pwd-dot {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #000;
}

.pwd-hidden-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 52px;
  opacity: 0;
  border: none;
  outline: none;
  font-size: 16px;
  color: transparent;
  caret-color: transparent;
  background: transparent;
  z-index: 2;
}
</style>
